// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"db39bf6b44a81bd4","894":"5dcea932044152cc"}[chunkId] + ".js";
};